import { render, staticRenderFns } from "./AwardTypeEdit.vue?vue&type=template&id=0c43012e&scoped=true"
import script from "./AwardTypeEdit.vue?vue&type=script&lang=js"
export * from "./AwardTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./AwardTypeEdit.vue?vue&type=style&index=0&id=0c43012e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c43012e",
  null
  
)

export default component.exports